import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RadnoMesto } from './radno-mesto';
import { BaseDataService, BaseTabsContainer, TabsContainerService, UserService } from 'yt-ng-framework';

@Component({
  selector: 'yt-radno-mesto-poslovi-tabs',
  templateUrl: './radno-mesto-poslovi-tabs.component.html'
})
export class RadnoMestoPosloviTabsComponent
 extends BaseTabsContainer<RadnoMesto> 
 implements OnInit{

  constructor(
    public tabsContainerService: TabsContainerService<RadnoMesto>,
    protected activatedRoute: ActivatedRoute,
    protected userService: UserService,
    protected baseDataService: BaseDataService
  ) { 
    super(tabsContainerService, activatedRoute, userService)
  }

  ngOnInit() {
    super.ngOnInit();
  }

}
